import { lazy } from 'react';

const AccountsGuidePage = lazy(() => import('../pages/AccountsGuide.page'));

const AccountsGuideRoutes = [
    {
        path: '/accounts-guide',
        element: <AccountsGuidePage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { AccountsGuideRoutes };
